import { render, staticRenderFns } from "./InquiriesIframe.vue?vue&type=template&id=cd1b8376&"
import script from "./InquiriesIframe.vue?vue&type=script&lang=ts&"
export * from "./InquiriesIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports